module.exports = __webpack_public_path__ + "718b80dad7b8e3b4e347ba5c24cfee8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Blue_Small_RGB.png
// module id = 110
// module chunks = 0